<template>
<!--  v-on:click="checkModule" -->
    <div class="com-item" :key="index">
        <div class="component person-nav">
            <div class="bb1"></div>
            <div class="van-sticky" v-if="modata.WContent.videoUrl" :style="{width:(modata.WContent.videoWidth||'100%'),height:(modata.WContent.videoHeight||200)+'px'}">

                <video style='width:100%;height:100%;' 
                  @loadedmetadata="getVideoAspectRatio"
                    :controls="modata.WContent.playType==0 ||!modata.WContent.playType" 
                    :loop="modata.WContent.loop==1" 
                    :autoplay="modata.WContent.autoplay==1" 
                    :poster="modata.WContent.poster"
                    :src="modata.WContent.videoUrl"
                    @play="videoPlay"
                    @pause="videoPause"
                    ref="video"
                    v-if="modata.WContent.playEffect!=1"
                    ></video>
                    <video style='width:100%;height:100%;' 
                       @loadedmetadata="getVideoAspectRatio"
                        :autoplay="false" 
                        :poster="modata.WContent.poster"
                        :src="modata.WContent.videoUrl"
                         @click="dialogVisible=true"
                         ref="video_frame"
                         v-else
                        ></video>

                    <div class="playType2" :class="{'v-icon_play':playStatus}" v-if="modata.WContent.playType==2">
                      <!-- <div class="v-btn" :style="modata.WContent|setBtnStyle" v-if="modata.WContent.btnType==1">
                        <button class="oper-btn" @click="handPlay" :style="modata.WContent.margin|setMargin(rootValue)">{{playStatus?"暂停播放":"立即播放"}}</button>
                      </div> -->
                      <btnModule :content-obj="modata.WContent" :nav="modata.WContent" :proportion="proportion" type="preview" :hand-back="true" @callback="handPlay" v-if="modata.WContent.btnType==1"></btnModule>
                      <span class="center v-icon" @click="handPlay" v-else>
                        <i class="fz-30 el-icon-caret-right i-pause" v-show="!playStatus"></i>
                        <i class="fz-30 i-play" v-show="playStatus">=</i>
                      </span>
                    </div>
                    <div class="center-dialog" v-if="modata.WContent.playEffect==1">
                      <el-dialog
                          v-if="dialogVisible"
                          title=""
                          :visible.sync="dialogVisible"
                          width="90%"
                          :before-close="handleClose">
                          <div style="width:100%;background:#000;position: relative;" :style="{height:(modata.WContent.videoHeight?modata.WContent.videoHeight*0.8:200)+'px'}">

                            <video style='width:100%;height:100%;' 
                              controls="true" 
                              :loop="modata.WContent.loop==1" 
                              autoplay="true" 
                              :poster="modata.WContent.poster"
                              :src="modata.WContent.videoUrl"
                              @play="videoPlay"
                              @pause="videoPause"
                              ref="video"
                              ></video>
                              <!-- <div class="playType2" :class="{'v-icon_play':playStatus}" v-if="modata.WContent.playType==2">
                                <span class="center v-icon" @click="operPlay">
                                  <i class="fz-30 el-icon-caret-right i-pause"  v-show="!playStatus"></i>
                                  <i class="fz-30 i-play" v-show="playStatus">=</i>
                                </span>
                              </div> -->

                          </div>
                          
                        </el-dialog>
                    </div>
                 


            </div>
        </div>
    </div>

</template>

<script>
import btnModule from "@/components/Custom/BtnModule";
export default {
  name: "video-module",
  components: {btnModule},
  props: {
    type: {
      //展示类型 preview预览模块 setting设置模块
      type: String,
      default: "preview",
    },
    index: {
      //索引
      type: Number,
    },
    phoneWidth: {
      type: Number,
      default:1280,
    },
    curpageWidth: {
      type: Number,
      default:1280,
    },
    proportion: {
        type: Number,
        default:1,
    },
    modata: {
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return {
          WName: "video",
          Title: "视频",
          WID: 1,
          ModuleName: "video-module",
          WContent: {},
          WHtml: "",
          
        
        };
      },
    },
  },
  data() {
    return {
      playStatus:false,
      currType:1,
      dialogVisible:false,
      rootValue:this.$store.state.rootValue||1,
    };
  },
  mounted() {
    let videoHeight= this.modata.WContent.videoHeight||0;
    if(videoHeight){
        videoHeight=videoHeight/this.phoneWidth*this.curpageWidth;
        this.modata.WContent.videoHeight=videoHeight;
    }
 
  },
  beforeDestroy() {},
  methods: {

   handPlay(){
    if(this.modata.WContent.playEffect!=1){
      this.operPlay();
    }else{
       this.dialogVisible=true
    }
   },

   operPlay(){
    this.playStatus?this.$refs.video.pause():this.$refs.video.play();
   },



    videoPlay(){
      this.playStatus=true;

    },
    videoPause(){
      this.playStatus=false;
    },
    handleClose(){
      this.$refs.video.pause();
      this.dialogVisible=false;
  
    },

     getVideoAspectRatio() {
      if(!this.modata.WContent.videoHeight){
        const video =this.modata.WContent.playEffect==1?this.$refs.video_frame:this.$refs.video;
        const aspectRatio = video.videoWidth / video.videoHeight;
        this.modata.WContent.videoHeight=this.curpageWidth/aspectRatio
      }

      // 你可以在这里根据aspectRatio来设置你的布局或其他逻辑
    }



  },
  filters: {
    setBtnStyle(WContent){
      let type={left:"flex-start",center:"center",right:"flex-end",}
      let style={
        justifyContent:type[WContent.btny]||"center",
        alignItems:type[WContent.btnx]||"center",
      };
      return style
    },
    setMargin(margin,rootValue){
      let style={};
       if(margin && margin.length){
        let newMargin=[0,0,0,0];
        margin.forEach((item,index) => {
          newMargin[index]=((item||0)/rootValue)+"px";
        });
        style.margin=newMargin.join(" ");
        return style;
      }

      return "";

    },
  },
  watch: {},
};
</script>
<style>
.center-dialog .el-dialog__wrapper{
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content: center;
}
.center-dialog .el-dialog{
 margin-top: 0 !important;
}
</style>
<style scoped>
  .van-sticky{
    position: relative;
  }
  .v-icon {
    position: absolute;
    opacity: 0.9;
    display: inline-block;
    width: 40px;
    height: 40px;
    background: #fff;
    border-radius: 20px;
    left: 50%;
    top: 50%;
    /* line-height: 32px; */
    text-align: center;
    margin-left: -20px;
    margin-top: -20px;
    cursor: pointer;
}
.v-icon i{
  line-height: 40px;

  font-family: Arial;
}
.v-icon .i-play{
  display: inline-block;
   transform: rotate(90deg);
}
.v-icon_play{
  display: none;
}
.van-sticky:hover .v-icon_play{
  display: block;
}
.fz-30{
  font-size: 30px;
}

/* 按钮 */
.v-btn{
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   display: flex;
   flex-direction: column;
   box-sizing: border-box;
   padding: 1px;
}
.v-btn .oper-btn{
  background-color: transparent;
  border: solid 1px #fff;
  color: #fff;
  line-height: 2;
  border-radius: 5px;
  font-size: 14px;
  letter-spacing: 2px;
  width: 20%;
  min-width: 120px;
  text-align: center;
}
.oper-btn:hover{
  background-color: #fff;
  border-color: #fff;
  color: #333;
}
</style>
